/** Classificação da frota leve (Samuel, 20/10/2026).
 *
 *  O cadastro de Frota ganha o campo, e só o veículo classificado aparece na aba Frota
 *  Leve do Mapa Operacional, com o ícone da classe no lugar do carro. Às 15h17 o
 *  Samuel trocou as classes do Word por estas, com os desenhos dele: as duas pessoas
 *  de capacete, a do operador fixo em amarelo, e os veículos com a chave inglesa,
 *  amarela na colheita e preta no transporte. O Caminhão manutenção transporte chegou
 *  às 15h20, e o Apoio garagem usa o ícone normal da frota leve, o do utilitário.
 *
 *  Módulo sem React, como `fleetTipos`: o marcador do mapa é DOM puro e usa o mesmo
 *  desenho da grade e do cadastro, pela URL da imagem. */

export const CLASSIFICACOES_FROTA_LEVE = [
  'operador', 'operador_fixo', 'mecanico_colheita', 'caminhao_manutencao_colheita',
  'manutencao_transporte', 'caminhao_manutencao_transporte', 'apoio_garagem',
] as const

export type ClassificacaoFrotaLeve = (typeof CLASSIFICACOES_FROTA_LEVE)[number]

/** Os tipos de veículo que recebem a classificação. Além da Frota Leve, a Aldeia
 *  rastreia caminhões de fazenda e de oficina e duas caminhonetes que o ERP publica
 *  como Outros. A mesma lista do backend, `CATEGORIAS_COM_CLASSIFICACAO`. */
export const CATEGORIAS_COM_CLASSIFICACAO: readonly string[] = ['utilitario', 'fazenda', 'outros']

/** O rótulo em português, o do cadastro de Frota. O Mapa traduz pela chave
 *  `mapa.unidades.classificacao.<valor>`. */
export const ROTULO_DA_CLASSIFICACAO: Record<ClassificacaoFrotaLeve, string> = {
  operador: 'Operador',
  operador_fixo: 'Operador fixo',
  mecanico_colheita: 'Mecânico colheita',
  caminhao_manutencao_colheita: 'Caminhão manutenção colheita',
  manutencao_transporte: 'Manutenção transporte',
  caminhao_manutencao_transporte: 'Caminhão manutenção transporte',
  apoio_garagem: 'Apoio garagem',
}

export function ehClassificacao(valor: unknown): valor is ClassificacaoFrotaLeve {
  return typeof valor === 'string' && (CLASSIFICACOES_FROTA_LEVE as readonly string[]).includes(valor)
}

/** Largura sobre altura da caixa do desenho. A pessoa é mais alta que larga e o
 *  veículo chega a 1,7; a caixa comum deixa o texto da grade alinhado. */
export const PROPORCAO_DO_ICONE = 1.7

/** A URL do desenho, para `<img>` na grade, no cadastro e no marcador do mapa. Desde
 *  23/10/2026 os desenhos seguem o padrão dos veículos da frota, com a ideia dos do
 *  Samuel: ver `vetores/prompts/classificacao`. São WebP de 88 pixels de altura, o
 *  quádruplo do marcador, como os de `assets/frota`. O do Apoio garagem é
 *  `frota/utilitario.svg` recortado do mesmo jeito. */
export function classificacaoIconUrl(classe: ClassificacaoFrotaLeve): string {
  return `/assets/classificacao/${classe}.webp`
}
